import { bool, func, shape, string } from 'prop-types';
import React from 'react';

import CampaignStatus from '../../campaign-editor/CampaignStatus';
import WaitForCampaignCreation from '../../campaign-editor/WaitForCampaignCreation';
import { PROJECT_VIEW } from '../../constants';
import ErrorComponent from '../../generic/Error';
import Loading from '../../generic/Loading';
import Titled from '../../layout/Titled';
import api from '../../REST/api';
import ProjectEntity from '../ProjectEntity';
import { ProjectEntityPropTypes } from '../ProjectEntity/ProjectEntity';

class ProjectCampaign extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      campaign: null,
      error: null,
    };
  }

  componentDidMount() {
    const { opportunityId } = this.props;
    const opportunityRequest = api.getOpportunity({ id: opportunityId });
    const campaignRequest = opportunityRequest.then(({ campaignId }) =>
      api.getCampaign({ id: campaignId }),
    );
    Promise.resolve(campaignRequest).then(
      campaign => {
        this.setState({
          campaign,
        });
      },
      error => this.setState({ error }),
    );
  }

  handleSave = e => {
    this.props
      .onSubmit(e, this.state.campaign)
      .then(this.props.entityProps.onSave);
  };

  renderTitle = campaign => {
    if (campaign) {
      const { opportunity } = campaign;
      let title = `${campaign.nCode} - ${opportunity.campaignObjective}`;
      if (opportunity.useCase) title = `${title} - ${opportunity.useCase}`;

      return (
        <div className="d-flex">
          <h4>{title}</h4>
          <div className="ml-2">
            <CampaignStatus status={campaign.status} />
          </div>
        </div>
      );
    }
    return <h4>Campaign</h4>;
  };

  render() {
    const { entityProps, isExpandable } = this.props;
    const { isEditing } = entityProps;
    const { campaign, error } = this.state;
    return (
      <ProjectEntity
        title={this.renderTitle(campaign)}
        {...entityProps}
        onSave={this.handleSave}
        onCancel={this.props.entityProps.onCancel}
        isExpandable={isExpandable}
      >
        {campaign ? (
          <WaitForCampaignCreation
            initialCampaign={campaign}
            view={PROJECT_VIEW}
            isEditing={isEditing}
          />
        ) : (
          <Titled title="">
            {error ? <ErrorComponent error={error} /> : <Loading />}
          </Titled>
        )}
      </ProjectEntity>
    );
  }
}

ProjectCampaign.propTypes = {
  opportunityId: string.isRequired,
  onChange: func.isRequired,
  onSubmit: func.isRequired,
  entityProps: shape(ProjectEntityPropTypes).isRequired,
  isExpandable: bool.isRequired,
};

export default ProjectCampaign;
